<template>
  <!-- 提现记录 -->
  <div class="withdraw-record">
    <div v-if="isInCpcnWhite === 1">
      <div class="container">
        <!-- tab切换 -->
        <div class="tab-content">
          <div
                  v-for="(item, index) of tabArr"
                  :key="index"
                  class="tab-btn"
                  :class="{ active: currentIndex === index }"
                  @click="handleTab(index)"
          >
            {{ item.tabName }}
          </div>
        </div>
        <!-- 搜索 -->
        <div class="search-wrap">
          <e-search
                  class="e-search"
                  :data="listQuery"
                  :field-list="fieldList"
                  @handleFilter="handleSearch"
                  @handleReset="handleClear"
                  :count="5"
          ></e-search>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table-content container">
        <table-list :loading="loading" :table-data="tableData" :table-label="tableLabel">
          <template #index="slotScope">
          <span>
            {{ (listQuery.pageNum - 1) * listQuery.pageSize + slotScope.scope.$index + 1 }}
          </span>
          </template>
          <template v-slot:amount="slot">
            {{
            slot.scope.row.amount ? (slot.scope.row.amount / 100).toFixed(2) : slot.scope.row.amount
            }}
          </template>
          <template #supplierCompanyName="slot">
            <span>{{ slot.scope.row.bankName }}: {{ slot.scope.row.bankCardNo }}</span>
          </template>
          <template v-slot:operation="slot">
            <el-button
                    @click.native.prevent="handleGoodsMaintenance(slot.scope.row)"
                    type="text"
                    size="small"
            >
              维护商品
            </el-button>
          </template>
        </table-list>
        <div class="pagination">
          <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :current-page="listQuery.pageNum"
                  :page-size="listQuery.pageSize"
                  :total="total"
                  prev-text="上一页"
                  next-text="下一页"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div v-if="isInCpcnWhite === 2" class="container">
      <no-permission />
    </div>
  </div>
</template>
<script>
import TableList from "@/modules/projectA/components/common/e-table-list";
import ESearch from "@/modules/projectA/components/common/e-search";
import Api from "@/modules/projectA/api/pay/index";
import noPermission from '../../components/pay/noPermission';
import _ from "lodash";
export default {
  data() {
    return {
      isInCpcnWhite:3,//1 是有白名单，2是没有
      tabArr: [
        { tabName: "处理中", badge: 10 },
        { tabName: "提现成功", badge: 10 },
        { tabName: "提现失败", badge: 10 },
      ],
      listQuery: {
        businessFlowNo: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
        status: 1,
      },
      cloneListQuery: {},
      loading: false,
      tableData: [],
      total: 0,

      currentIndex: 0,
      fieldList: [
        { label: "交易流水号", type: "input", value: "businessFlowNo" },
        {
          label: "发起时间",
          type: "date",
          value: "time",
          dateType: "datetimerange",
          valueFormat: "yyyy-MM-dd HH:mm:ss",
          defaultTime: ["00:00:00", "23:59:59"],
        },
      ],
      cloneTableLabel: [],
      tableLabel: [
        { label: "序号", align: "center", slot: "index", fixed: "left", width: "80px" },
        {
          label: "交易流水号",
          param: "businessFlowNo",
          align: "center",
          minWidth: "200",
        },
        {
          label: "提现金额(元)",
          param: "amount",
          align: "center",
          minWidth: "200",
          slot: "amount",
        },
        {
          label: "发起时间",
          param: "createTime",
          align: "center",
          minWidth: "200",
        },
        {
          label: "提现至银行卡",
          align: "center",
          minWidth: "210",
          slot: "supplierCompanyName",
        },
        {
          label: "当前状态",
          param: "statusDesc",
          align: "center",
          minWidth: "210",
        },
        /* {
          label: "失败原因",
          param: "purchaserList",
          align: "center",
          minWidth: "100",
        }, */
        /* { label: "操作", align: "center", slot: "operation", minWidth: "200", fixed: "right" }, */
      ],
    };
  },
  components: { ESearch, TableList,noPermission },
  mounted() {
    this.isInCpcnWhiteList();
  },
  methods: {
    async isInCpcnWhiteList(){
      let res = await Api.isInCpcnWhiteList();
      if (res.success) {
        if(res.data){
          this.isInCpcnWhite = 1;
          this.cloneListQuery = _.cloneDeep(this.listQuery);
          this.cloneTableLabel = _.cloneDeep(this.tableLabel);
          this.getList(this.listQuery);
        }else{
          this.isInCpcnWhite = 2;
        }
      }
    },

    handleTab: _.debounce(function(index) {
      this.currentIndex = index;
      this.listQuery.status = index + 1;
      if (this.listQuery.status === 3) {
        this.tableLabel.push({
          label: "失败原因",
          param: "errorInfo",
          align: "center",
          minWidth: "100",
        });
      } else {
        this.tableLabel = [...this.cloneTableLabel];
      }
      this.$nextTick(() => {
        this.getList(this.listQuery);
      });
    }, 300),
    //
    async getList(params) {
      try {
        const res = await Api.withdrawCashPage(params);
        const data = res.data;
        this.tableData = [...data.records];
        this.total = data.total;
      } catch (err) {
        console.log(err);
      }
    },
    handleSearch(val) {
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      console.log(this.listQuery);
      if (val.time) {
        this.listQuery.startTime = val.time[0];
        this.listQuery.endTime = val.time[1];
      }

      this.getList(this.listQuery);
    },
    handleClear() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },
    handleSizeChange(pageSize) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = pageSize;
      this.getList(this.listQuery);
    },
    handleCurrentChange(pageNum) {
      this.listQuery.pageNum = pageNum;
      this.getList(this.listQuery);
    },
  },
};
</script>
<style lang="scss" scoped>
.withdraw-record {
  padding: 10px;
  width: 100%;
  .tab-content {
    display: flex;
    align-items: center;
    .tab-btn {
      width: 234px;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      // border: 1px solid #DCDFE6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      // border-radius: 4px;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;
      &:last-child {
        border-right: 1px solid #d9d9d9;
      }
      &.active {
        position: relative;
        background: #f4f7ff;
        color: #0064c8;
        border-top: 2px solid #0064c8;
        border-bottom: 0;
        z-index: 10;
      }
    }
  }
  .search-wrap {
    padding: 10px;
    width: 100%;
    border: 1px solid #d9d9d9;
    position: relative;
    top: -1px;
    .search-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        flex: 0 0 316px;
      }
      .el-input {
        width: 200px;
      }
    }
    .search-btn {
      text-align: center;
    }
  }

  .table-content {
    margin-top: 10px;
  }
  .handle-btn {
    text-align: right;
    padding: 10px 0;
  }
  .pagination {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
